import React, { useContext } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles'
import { AppBar, Toolbar, Typography, Container, Grid, Button,
  Box, Tooltip, IconButton, LinearProgress, ToggleButton } from '@mui/material'
import { Brightness7, Brightness4, SlowMotionVideo as SlowMotionVideoIcon,
  PlayCircleOutline as PlayCircleOutlineIcon } from '@mui/icons-material'
import { ColorModeContext } from '../../contexts'
import { GetSlides, PostDiagnosis } from '../../utils/apiManager'


function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress {...props} color="inherit" />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="inherit">{props.rawvalue + '/' + props.total}</Typography>
      </Box>
    </Box>
  );
}

export default function Header(props) {
  const theme = useTheme()
  const colorMode = useContext(ColorModeContext)
  const navigate = useNavigate()
  
  const [activeSlide, setActiveSlide] = React.useState(0)
  const [validatedSlide, setValidatedSlide] = React.useState(-1)
  const [diagnosesValues, setDiagnosesValues] = React.useState([])
  const [slowMotion, setSlowMotion] = React.useState(false)

  const MIN = 0
  const normalise = (value) => ((value - MIN) * 100) / (slides.length - MIN)
  const validateSlide = (diagnosisValue) => {
    const user_id = localStorage.getItem('user_id') === 'null' ? null : localStorage.getItem('user_id')
    PostDiagnosis(diagnosisValue, slides[activeSlide].slide_name, user_id).catch((e) => {
      console.log(e)
    }).finally(() => {
      setDiagnosesValues([...diagnosesValues, diagnosisValue])
      setValidatedSlide(validatedSlide+1)
      if(validatedSlide+1 === slides.length - 1) {
        navigate("/result")
      } else {
        setActiveSlide(activeSlide+1)
      }
    })
  }

  const previousSlide = () => {
    setActiveSlide(activeSlide-1)
  }

  const nextSlide = () => {
    setActiveSlide(activeSlide+1)
  }

  const resetGame = () => {
    navigate("/login")
  }

  const goToSlide = (id) => {
    setActiveSlide(id-1)
    navigate("/viewer")
  }

  const goToResultList = () => {
    navigate("/result")
  }

  const [slides, setSlides] = React.useState([])

  const getData=()=>{
    GetSlides().then(function(myJson) {
      myJson = JSON.parse(myJson)
      console.log(myJson)
      let tempSlides = [...myJson].sort(() => 0.5 - Math.random())
      tempSlides = tempSlides.slice(0, 5)
      tempSlides.forEach((slide, index) => {
        slide.id = index+1
        slide.diagnosis = slide.diagnostic_datas.diagnosis
        slide.visiocyt = slide.diagnostic_datas.visiocyt
        slide.endoscopie = slide.diagnostic_datas.endoscopie
      })
      setSlides(tempSlides)
    }).catch(e => {
      console.log('Could not get slides ' + e)
    })
  }
  
  React.useEffect(() => {
    getData()
  }, [])
  
  return (
    <div style={{ height: '100%' }}>  
      <AppBar position="fixed">
        <Toolbar variant="dense" style={{ backgroundColor: "#0D9ED3" }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <img src="/logo.svg" height={30} width={120} alt="vitadx-logo"/>

            <div>
              {validatedSlide <= activeSlide && validatedSlide !== slides.length-1 &&
                <b>Lame {activeSlide+1}</b>
              }
            </div>

            <div style={{ width: '30%' }}>
              {validatedSlide <= activeSlide && validatedSlide !== slides.length-1 &&
                <div>
                  <LinearProgressWithLabel variant="determinate" value={normalise(validatedSlide+1)}
                  rawvalue={validatedSlide+1} total={slides.length}/>
                </div>
              }
            </div>

             <Button variant="outlined" onClick={resetGame} color='white'>Réinitialiser</Button>

            <div>
              { !(validatedSlide <= activeSlide && validatedSlide !== slides.length-1) &&
                <Tooltip title={slowMotion ? 'Normal mode' : 'Slow mode'} placement='bottom'>
                  <ToggleButton
                    value="check"
                    selected={slowMotion}
                    onChange={() => {
                      setSlowMotion(!slowMotion)
                    }}
                    color='white'
                  >
                    { slowMotion ?
                      <PlayCircleOutlineIcon color='white'/>
                      :
                      <SlowMotionVideoIcon color='white'/>
                    }
                  </ToggleButton>
                </Tooltip>
              }

              <Tooltip title={theme.palette.mode === 'dark' ? 'Briht mode' : 'Dark mode'} placement='bottom'>
                <IconButton sx={{ ml: 1 }} onClick={colorMode.toggleColorMode} color='inherit'>
                  {theme.palette.mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
                </IconButton>
              </Tooltip>
            </div>
          </Grid>
        </Toolbar>
      </AppBar>
      <Container maxWidth={false} component="main" style={{ height: '100%', paddingTop: '55px' }}>
        <Outlet context={[slides, activeSlide, validatedSlide, diagnosesValues, validateSlide, previousSlide, nextSlide, goToSlide, goToResultList, slowMotion]}/>
      </Container>
    </div>
  )
}